import jexl from 'jexl';

export default {
  eval: function(expression, context) {
    if (expression.includes('===')) {
      expression = expression.replace('===', '==');
    }
    return jexl.evalSync(expression, context);

  }
};
